import React from 'react';
export function SymptomGuideCTA() {
  const symptoms = [{
    name: 'Hot flashes',
    icon: <FlameIcon data-id="element-371" />
  }, {
    name: 'Brain fog',
    icon: <CloudIcon data-id="element-372" />
  }, {
    name: 'Tingling hands',
    icon: <HandIcon data-id="element-373" />
  }, {
    name: 'Gum sensitivity',
    icon: <ToothIcon data-id="element-374" />
  }, {
    name: 'Ringing ears',
    icon: <EarIcon data-id="element-375" />
  }, {
    name: 'Sudden rage',
    icon: <LightningIcon data-id="element-376" />
  }];
  return <section className="w-full bg-orla-bone py-16 md:py-32" data-id="element-377">
      <div className="mx-auto max-w-[1240px] px-6 md:px-8" data-id="element-378">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-20 items-center" data-id="element-379">
          {/* Left Column */}
          <div className="md:col-span-6 flex flex-col items-start" data-id="element-380">
            <span className="font-body text-[13px] font-semibold uppercase tracking-[0.06em] text-orla-saffron" data-id="element-381">
              FREE GUIDE
            </span>

            <h2 className="mt-4 max-w-[440px] font-display text-[32px] font-black leading-[1.1] tracking-[-0.02em] text-orla-ink md:text-[48px]" data-id="element-382">
              100+ perimenopause symptoms. Most women only know 5.
            </h2>

            <p className="mt-6 max-w-[480px] font-body text-[17px] leading-[1.6] text-orla-muted" data-id="element-383">
              Download our free symptom guide and learn the signs your doctor
              might miss — from tingling hands to sudden rage, from gum
              sensitivity to ringing ears. Know what's happening to your body.
            </p>

            <button className="mt-8 rounded-full bg-orla-sienna px-8 py-3.5 font-body text-[15px] font-semibold text-orla-bone transition-colors hover:bg-orla-sienna/90" data-id="element-384">
              Get the Free Guide
            </button>

            <p className="mt-4 font-body text-[13px] text-orla-muted" data-id="element-385">
              No email spam. Instant PDF download.
            </p>
          </div>

          {/* Right Column - Phone Mockup */}
          <div className="md:col-span-6 flex justify-center" data-id="element-386">
            <div className="relative h-[640px] w-full max-w-[320px] -rotate-4 overflow-hidden rounded-[40px] border-[12px] border-orla-ink bg-orla-bone shadow-[0_24px_64px_rgba(31,27,23,0.16)]" data-id="element-387">
              {/* Top Nav */}
              <div className="flex h-[56px] w-full items-center justify-center border-b border-orla-border/50 bg-orla-bone" data-id="element-388">
                <span className="font-display text-[18px] font-black lowercase text-orla-sienna" data-id="element-389">
                  orla
                </span>
              </div>

              {/* Content Area */}
              <div className="h-[calc(100%-56px-48px)] w-full bg-orla-bone p-4" data-id="element-390">
                <h3 className="font-display text-[18px] italic text-orla-ink" data-id="element-391">
                  Symptoms A–Z
                </h3>

                <div className="mt-3 flex flex-col gap-3" data-id="element-392">
                  {symptoms.map((symptom, idx) => <div key={idx} className="flex items-center gap-3 rounded-xl bg-white px-3 py-2.5 shadow-sm" data-id="element-393">
                      <div className="flex h-[18px] w-[18px] items-center justify-center text-orla-sienna" data-id="element-394">
                        {symptom.icon}
                      </div>
                      <span className="flex-1 font-body text-[13px] font-medium text-orla-ink" data-id="element-395">
                        {symptom.name}
                      </span>
                      <span className="text-orla-saffron" data-id="element-396">→</span>
                    </div>)}
                </div>
              </div>

              {/* Bottom Nav */}
              <div className="absolute bottom-0 flex h-[48px] w-full items-center justify-around border-t border-orla-border/50 bg-orla-bone px-4" data-id="element-397">
                <div className="flex flex-col items-center gap-1" data-id="element-398">
                  <div className="h-4 w-4 rounded-full border-2 border-orla-muted/40" data-id="element-399"></div>
                </div>
                <div className="flex flex-col items-center gap-1" data-id="element-400">
                  <div className="h-4 w-4 rounded-sm border-2 border-orla-saffron" data-id="element-401"></div>
                  <div className="h-1 w-1 rounded-full bg-orla-saffron" data-id="element-402"></div>
                </div>
                <div className="flex flex-col items-center gap-1" data-id="element-403">
                  <div className="h-4 w-4 rounded-full border-2 border-orla-muted/40" data-id="element-404"></div>
                </div>
                <div className="flex flex-col items-center gap-1" data-id="element-405">
                  <div className="h-4 w-4 rounded-full border-2 border-orla-muted/40" data-id="element-406"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
// Simple Inline SVGs for the phone mockup
function FlameIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-full w-full" data-id="element-407">
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" data-id="element-408" />
    </svg>;
}
function CloudIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-full w-full" data-id="element-409">
      <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" data-id="element-410" />
    </svg>;
}
function HandIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-full w-full" data-id="element-411">
      <path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0" data-id="element-412" />
      <path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2" data-id="element-413" />
      <path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8" data-id="element-414" />
      <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15" data-id="element-415" />
    </svg>;
}
function ToothIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-full w-full" data-id="element-416">
      <path d="M12 22s-2-1-2-5a3 3 0 0 1 3-3 3 3 0 0 1 3 3c0 4-2 5-2 5" data-id="element-417" />
      <path d="M7 10c0-3.3 2.7-6 6-6s6 2.7 6 6c0 1.5-.5 2.8-1.3 3.8L12 22l-5.7-8.2C5.5 12.8 5 11.5 5 10z" data-id="element-418" />
    </svg>;
}
function EarIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-full w-full" data-id="element-419">
      <path d="M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a1 1 0 0 1-2 0c0-4.5 6-4.5 6-10a4.5 4.5 0 1 0-9 0c0 2.5-1.5 3-1.5 3" data-id="element-420" />
    </svg>;
}
function LightningIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-full w-full" data-id="element-421">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" data-id="element-422" />
    </svg>;
}